import * as React from "react";
const SvgPlayArrow = props => /*#__PURE__*/React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 5v14l11-7L8 5Z",
  fill: "currentColor"
}));
export default SvgPlayArrow;